import * as yup from "yup";


const TrustedPartnerApplicationSchema = yup.object({
    companyName: yup
        .string()
        .required('Please enter company name')
        .max(100, 'Company name must be less than 100 characters'),
        
    companyRep: yup
        .string()
        .required('Please enter company representative name')
        .max(100, 'Representative name must be less than 100 characters'),
        
    address: yup
        .string()
        .required('Please enter address'),
        
    city: yup
        .string()
        .required('Please enter city'),
        
    state: yup
        .string()
        .length(2, 'State must be 2 characters')
        .required('Please enter state'),
        
    zip: yup
        .string()
        .length(5, 'Zip Code must be 5 digits')
        .matches(/^\d{5}$/, 'Zip must be 5 digits')
        .required('Please enter zip code'),
        
    regions: yup
        .array(yup.string().required())
        .min(1, 'Please select at least one region')
        .required('Please select regions'),
        
    phone: yup
        .string()
        .matches(/^[0-9]+$/, "Phone number can only contain digits")
        .transform((value) => value.replace(/[^0-9]/g, ''))
        .length(10, 'Phone must be exactly 10 digits')
        .required('Please enter phone number'),
        
    email: yup
        .string()
        .email("Please enter a valid email address")
        .required("Please enter email address"),
        
    employees: yup  
        .string()
        .required('Please select number of employees'),
        
    numberOfBranches: yup
        .number()
        .positive('Number of branches must be positive')
        .integer('Number of branches must be a whole number')
        .required('Please enter number of branches'),
        
    reasonForApplication: yup
        .string()
        .required('Please provide reason for application')
        .min(50, 'Reason must be at least 50 characters')
        .max(1000, 'Reason must be less than 1000 characters'),
        
    whyClientVitals: yup
        .string()
        .required('Please explain why you want Client Vitals Services')
        .min(50, 'Response must be at least 50 characters')
        .max(1000, 'Response must be less than 1000 characters'),
        
    websiteLink: yup
        .string()
        .required('Please enter website URL')
        .transform((value) => {
            if (!value) return value;
            
            let url = value.trim();
            
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            
            if (url.startsWith('www.')) {
                return `https://${url}`;
            }
            
            return `https://www.${url}`;
        })
        .url('Please enter a valid website URL'),
        
    logo: yup
        .mixed<FileList>()
        .test('fileRequired', 'Please upload company logo', (value) => {
            return value && value.length > 0;
        })
        .test('fileType', 'Only image files are allowed', (value) => {
            if (!value || value.length === 0) return false;
            const file = value[0];
            return file && ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
        })
        .test('fileSize', 'File size must be less than 5MB', (value) => {
            if (!value || value.length === 0) return false;
            const file = value[0];
            return file && file.size <= 5 * 1024 * 1024;
        })
        .required('Please upload company logo'),
        
    servicesNeeded: yup
        .array(yup.string().required())
        .min(1, 'Please select at least one service')
        .required('Please select needed services'),
});


export default TrustedPartnerApplicationSchema;


